module.exports = __webpack_public_path__ + "static/media/notFound.2b0b9726.png";